enum LineItemOrigin {
  dsp = 'dsp',
  ssp = 'adServer',
  auto = 'deal',
}

export default LineItemOrigin;
